export default __webpack_public_path__ + "media/Dairy-Cheese.aa001963.png";